import api from "../store/services/api";

export const getSubscriptionPlans = () => api.get("/subscriptions/plans/");

export const getMySubscription = () => api.get("/subscriptions/my-subscription/");

export const getSubscriptionExpiryAlert = () =>
  api.get("/subscriptions/expiry-alert/");

export const getSubscriptionUsage = () => api.get("/subscriptions/usage/");

export const upgradeSubscription = (data) =>
  api.post("/subscriptions/upgrade/", data, {
    headers: { "Content-Type": "application/json" },
  });

export const createStripeCheckoutSession = ({ plan_id, billing_cycle }) =>
  api.post(
    "/subscriptions/stripe/checkout/",
    { plan_id, billing_cycle },
    { headers: { "Content-Type": "application/json" } },
  );

export const createStripePortalSession = () =>
  api.post("/subscriptions/stripe/portal/", {}, {
    headers: { "Content-Type": "application/json" },
  });

export const cancelStripeSubscription = (at_period_end = true) =>
  api.post(
    "/subscriptions/stripe/cancel/",
    { at_period_end },
    { headers: { "Content-Type": "application/json" } },
  );
